export enum TimeTrackingEventTypes {
    ITEM_BASED = 0,
    USER_BASED = 1
}